let scrollLockCount = 0;
let savedBodyOverflow = "";

function applyScrollLock() {
  if (typeof document === "undefined") {
    return;
  }

  savedBodyOverflow = document.body.style.overflow;
  // body uses scrollbar-gutter: stable (index.pcss) — do not add padding-right (double shift).
  document.body.style.overflow = "hidden";
}

function applyScrollUnlock() {
  if (typeof document === "undefined") {
    return;
  }

  document.body.style.overflow = savedBodyOverflow;
}

export function lockModalPageScroll() {
  scrollLockCount += 1;

  if (scrollLockCount !== 1) {
    return;
  }

  applyScrollLock();
}

export function unlockModalPageScroll() {
  scrollLockCount = Math.max(0, scrollLockCount - 1);

  if (scrollLockCount > 0) {
    return;
  }

  applyScrollUnlock();
}

export function forceUnlockModalPageScroll() {
  scrollLockCount = 0;
  applyScrollUnlock();
}
